import { register } from '@/js/api/auth.ts';
import { clearField, FIELD_SELECTOR, showFieldError } from '@/js/fields.ts';
import { clearPhone } from '@/js/helper/clear-phone.ts';
import { ERROR_REQUEST_TEXT, showErrorNotify } from '@/js/notification.ts';

function clearFormFields(form: HTMLFormElement) {
  const fields = form.querySelectorAll<HTMLElement>(FIELD_SELECTOR);
  for (const field of fields) {
    clearField(field);
  }
}
export function initRegisterForm() {
  const form = document.querySelector<HTMLFormElement>('.js-form-register');
  if (!form)
    return;

  form.addEventListener('submit', handleRegisterFormSubmit);

  function handleRegisterFormSubmit(event: Event): void {
    event.preventDefault();
    if (!form) {
      return;
    }
    clearFormFields(form);
    void registerFormAsync(form);
  }

  async function registerFormAsync(form: HTMLFormElement): Promise<void> {
    const formData = new FormData(form);
    const password = formData.get('password')?.toString() ?? '';
    const passwordConfirmation = formData.get('password_confirmation')?.toString() ?? '';

    const phone = formData.get('phone') ?? '';
    if (typeof phone === 'string') {
      formData.set('phone', clearPhone(phone));
    }
    if (password !== passwordConfirmation) {
      showFieldError(form.querySelector('[name="password"]'), 'Ошибка! Пароли не совпадают');
      return;
    }
    if (password.length < 8) {
      showFieldError(form.querySelector('[name="password"]'), 'Ошибка! Пароль меньше 8 символов');
      return;
    }

    try {
      const response = await register(formData);
      if (response.data?.success && (response.data.redirect_url != null)) {
        window.location.href = response.data.redirect_url;
      }
      else {
        showErrorNotify({ text: ERROR_REQUEST_TEXT });
      }
    }
    catch (error) {
      showErrorNotify({ text: ERROR_REQUEST_TEXT });
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }
}
